import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './components/pages/error-page/error-page.component';
import { HomeComponent } from './components/pages/home/home.component';
import { ChatTasaLayoutAssistanceComponent } from './components/pages/chat-tasa-layout-assistance/chat-tasa-layout-assistance.component';
import { EmbeddedOnlyGuard } from './services/embedded-only.guard';

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 90],
    useHash: false
};

const routes: Routes = [
    { path: '', redirectTo: 'inicio', pathMatch: 'full' },
    { path: 'inicio', component: HomeComponent},
    {
        path: 'chat-tasa',
        component: ChatTasaLayoutAssistanceComponent,
        canActivate: [EmbeddedOnlyGuard] // ← LÍNEA 2
    },
    { path: 'error', component: ErrorPageComponent },
    { path: '**', redirectTo: 'error' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
